<template lang="pug">
v-navigation-drawer(
  v-if="isUserValid"
  fixed
  clipped
  v-model="showSideNav"
  app
  width="400"
  style="overflow-y: auto;"
  id="navDraw"
)
  div.nav-spliter
      v-slide-y-transition
        div(v-if="showSideNav").side-nav-left-close-arrow
            a(href="javascript:void(0);" @click.stop="toggleSideNav")
              img(:src="closeButton()"
                  width="31px"
                  alt="Close"
                )
  div.text-xs-center.mt-3
    img(
      :src="client.logoUri"
      alt="Logo"
    ).logo-side-nav
    p.display-name {{ client.displayName }}
  div.text-xs-center.pl-3.pr-3.mt-3.ml-2.mr-2(v-if="!isPreferencesView"  id="nav-container")
    v-expansion-panel(
      focusable
      expand
      v-model="expansionPanelStates"
    ).panel
      v-expansion-panel-content(
        v-for="(cemodule, index) in moduleItems"
        :key="cemodule.actionItem.id"
        :id="'panel-' + cemodule.actionItem.id"
        style="background-color: #f8fbfe;"
      )
        div(slot="header").nav-item
          v-badge(
            v-if="(cemodule.updateItem!=null)&&(isAllowedTo(4)||isAllowedTo(3)||isAllowedTo(2))"
            left
            color="secondary"
          )
            v-btn(
              slot="badge"
              flat
              icon
              dark
              small
              :ripple="false"
              @click.stop="showUpdateDetail( \
                    cemodule.updateItem.summary, \
                    cemodule.updateItem.publish.publishId, \
                    cemodule.updateItem.publish.moduleId \
                    )"
            ).updateButton {{cemodule.updateItem.updateNumber}}
          div.nav-item-inner
            span.nav-word
              | {{ cemodule.actionItem.displayName }}
        v-card(style="background-color: #f8fbfe;")
          v-card-text(@click="")
            toc(
              v-if="tocs[index]"
              :toc="[tocs[index].toc]"
              :moduleId="cemodule.actionItem.id"
              @pageSelected="onPageSelected"
              :id="'toc-' + cemodule.actionItem.id"
              :resetActive="resetActive"
              ref="tree"
              style="max-width:300px"
            )
  show-update-c-e-module-dialog(
        :summary="summary"
        :show-dialog="showUpdateDialog"
        :diff="diff"
        :publishId="merge.publishId"
        :moduleId="merge.moduleId"
        @closed="showUpdateDialog=false"
        @updateSideNav="updateSideNav"
  )
  check-for-updates-message-dialog(
        :message="message"
        :title="title"
        :show-dialog="showCheckUpdateMessageDialog"
        @closed="showCheckUpdateMessageDialog=false"
  )
  div.text-xs-center.pt-3.mt-4.ml-3.mr-3(v-if="isPreferencesView" id="nav-container-preferences")
    v-list(dense).pt-0
      v-list-tile(@click="showSettingsView")
        v-list-tile-action
          v-icon settings
        v-list-tile-content
          v-list-tile-title Settings
      v-list-tile(@click="showContextView")
        v-list-tile-action
          v-icon view_list
        v-list-tile-content
          v-list-tile-title Context
      v-list-tile(@click="showGroupAdminView" v-if="isGroupAdmin()")
        v-list-tile-action
          v-icon mouse
        v-list-tile-content
          v-list-tile-title Group Admin
  div.text-xs-center.mt-3.logo-side-bottom-nav
    img(src="../../resources/assets/logo-left-bottom.png" alt="Logo")
  div.text-xs-center.mt-3.version-side-bottom-nav
    span() &copy;2019 CompliSpace (v{{version}}). All rights reserved.
</template>

<script>
import treeUtils from '@/lib/treeutils';
import _ from 'lodash';
import striptags from 'striptags';
import nunjucks from 'nunjucks';
import VueScrollTo from 'vue-scrollto';
import { mapState, mapGetters, mapMutations } from 'vuex';
import * as types from '@/store/mutationTypes';
import { content, publish } from '@/api';
import Base from '@/components/views/Base';
import CEModuleTOC from '@/components/content/CEModuleTOC';
import mergeFieldToLowerCase from '@/lib/util';
import ShowUpdateCEModuleDialog from '../content/ShowUpdateCEModuleDialog';
import CheckForUpdatesMessageDialog from '../content/CheckForUpdatesMessageDialog';

const md = require('markdown-it')({
    html: true
});

const packageParam = require('../../../package.json');

export default {
    name: 'AppSideNav',

    extends: Base,

    components: {
        toc: CEModuleTOC,
        ShowUpdateCEModuleDialog,
        CheckForUpdatesMessageDialog
    },

    data() {
        return {
            showUpdateDialog: false,
            showCheckUpdateMessageDialog: false,
            tocs: [],
            tocActive: '',
            expansionPanelStates: [],
            resetActive: false,
            moduleUpdates: [],
            diff: '',
            summary: '',
            moduleItems: [],
            message: '',
            title: '',
            moduleId: null,
            merge: { publishId: -1, moduleId: -1 }
        };
    },

    computed: {
        ...mapState({
            app: state => state.app,
            ceapps: state => state.ceapps,
            cemodules: state => state.cemodules,
            isPreferencesView: state => state.appearance.isPreferencesView,
            currentPage: state => state.navigation.currentPage,
            navigation: state => state.navigation.navigation,
            client: state => state.client,
            role: state => state.session.role
        }),

        ...mapGetters({
            appliedUpdateItems: 'published/appliedItems',
            activatedCEModuleItems: 'activatedCEModules/items',
            contextItemValues: 'clientContext/values',
            isAuthenticated: 'session/isAuthenticated',
            isUserValid: 'session/isUserValid',
            complispacePublishedItems: 'published/complispaceItems',
            activatedCEModules: 'activatedCEModules/items',
            isAllowedTo: 'session/isAllowedTo',
            hasAccess: 'session/hasAccess'
        }),

        showSideNav: {
            get() {
                return this.$store.state.appearance.showSideNav;
            },

            set(value) {
                this.$store.commit(types.APPEARANCE_SET_SIDE_NAV, value);
            }
        },

        version() {
            const bundleVersion = packageParam.bundleVersion;
            const uiVersion = packageParam.version;
            const dashApiVersion = this.app.apiVersion ? `-${this.app.apiVersion}` : '';
            const contentEngineVersion = this.app.ceVersion ? `-${this.app.ceVersion}` : '';
            return `${bundleVersion}#${uiVersion}${dashApiVersion}${contentEngineVersion}`;
        }
    },

    watch: {
        activatedCEModuleItems() {
            this.getTableOfContents();
        },

        currentPage(newValue, oldValue) {
            // Sanity checks
            if (!newValue) return;
            if (_.isEqual(newValue, oldValue)) return;
            const { moduleId, path } = newValue;
            this.moduleId = moduleId;
            // Do not animate TOC if the already on the correct TOC node
            // e.g. when the user selects the page from the TOC directly.
            if (this.tocActive === path) return;
            this.moduleId = moduleId;
            // this.animateTOC(moduleId, path);
        },

        contextItemValues() {
            // TODO: Only redraw with new context values instead of getting
            // the whole TOC from server again;
            this.getTableOfContents();
        },

        // Reload the module update patch notes after module update dialog
        // closes.
        // showUpdateDialog(newValue) {
        //     if (!newValue) {
        //         this.getUpdate(false);
        //     }
        // }
    },

    async beforeCreate() {
        try {
            await this.$store.dispatch('published/getAllAppliedUpdates');
            await this.$store.dispatch('published/getAllComplispaceUpdates');
        } catch (error) {
            console.log(error);
        }
    },

    methods: {
        closeButton() {
            return this.remapColors('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20viewBox%3D%22-1%202.926%2086.832%20280.535%22%20width%3D%2283%22%20height%3D%22277%22%3E%3Cdefs%3E%3Cpath%20d%3D%22M79.39%20278.59l-5.21-3.1-5.07-3.29-4.93-3.47-4.79-3.66-4.64-3.84-4.5-4.01-4.33-4.17-4.17-4.34-4.01-4.49-3.83-4.65-3.66-4.8-3.47-4.93-3.29-5.07-3.09-5.21-2.9-5.33-2.69-5.46-2.49-5.57-2.27-5.68-2.06-5.79-1.83-5.89-1.6-5.98-1.37-6.08-1.14-6.17-.89-6.24-.64-6.32-.39-6.4-.13-6.46.13-6.46.39-6.39.64-6.32.89-6.25%201.14-6.16%201.37-6.08%201.6-5.99%201.83-5.89%202.06-5.79%202.27-5.68%202.49-5.57%202.69-5.45%202.9-5.33%203.09-5.21%203.29-5.07%203.47-4.94%203.66-4.79%203.83-4.65%204.01-4.49%204.17-4.34%204.33-4.18%204.5-4.01%204.64-3.83%204.79-3.66%204.93-3.48%205.07-3.28%205.21-3.1%203.44-1.87v276.53l-3.44-1.87z%22%20id%3D%22close-a%22%2F%3E%3Cpath%20d%3D%22M65.9%20111.02c-.26.8-5.42%208.73-11.64%2017.86-6.48%209.26-10.97%2017.19-10.58%2018.25.4%201.06%205.29%208.86%2011.11%2017.46%205.69%208.59%2010.72%2016.26%2011.25%2017.06.39.79-.8%203.83-2.91%206.88-.24.36-1.43%202.16-3.58%205.42l-16.13-23.68-16.14-23.8c9.53-14.29%2014.82-22.22%2015.87-23.81%208.73-13.09%2016.01-23.81%2016.27-23.81.13%200%201.72%202.39%203.57%205.43%201.86%202.91%203.18%205.95%202.91%206.74z%22%20id%3D%22close-c%22%2F%3E%3C%2Fdefs%3E%3Cuse%20xlink%3Ahref%3D%22%23close-a%22%20fill%3D%22%23fff%22%2F%3E%3Cuse%20xlink%3Ahref%3D%22%23close-a%22%20fill-opacity%3D%220%22%20stroke%3D%22%230928f8%22%20stroke-width%3D%220%22%2F%3E%3Cfilter%20id%3D%22close-b%22%20x%3D%22-9%22%20y%3D%22-5.07%22%20width%3D%22101.83%22%20height%3D%22295.54%22%20filterUnits%3D%22userSpaceOnUse%22%3E%3CfeFlood%2F%3E%3CfeComposite%20in2%3D%22SourceAlpha%22%20operator%3D%22out%22%2F%3E%3CfeGaussianBlur%20stdDeviation%3D%221%22%2F%3E%3CfeOffset%20dx%3D%221%22%20dy%3D%221%22%20result%3D%22afterOffset%22%2F%3E%3CfeFlood%20flood-color%3D%22%23fff%22%20flood-opacity%3D%22.8%22%2F%3E%3CfeComposite%20in2%3D%22afterOffset%22%20operator%3D%22in%22%2F%3E%3CfeMorphology%20operator%3D%22dilate%22%20radius%3D%221%22%2F%3E%3CfeComposite%20in2%3D%22SourceAlpha%22%20operator%3D%22in%22%2F%3E%3C%2Ffilter%3E%3Cpath%20d%3D%22M79.39%20278.59l-5.21-3.1-5.07-3.29-4.93-3.47-4.79-3.66-4.64-3.84-4.5-4.01-4.33-4.17-4.17-4.34-4.01-4.49-3.83-4.65-3.66-4.8-3.47-4.93-3.29-5.07-3.09-5.21-2.9-5.33-2.69-5.46-2.49-5.57-2.27-5.68-2.06-5.79-1.83-5.89-1.6-5.98-1.37-6.08-1.14-6.17-.89-6.24-.64-6.32-.39-6.4-.13-6.46.13-6.46.39-6.39.64-6.32.89-6.25%201.14-6.16%201.37-6.08%201.6-5.99%201.83-5.89%202.06-5.79%202.27-5.68%202.49-5.57%202.69-5.45%202.9-5.33%203.09-5.21%203.29-5.07%203.47-4.94%203.66-4.79%203.83-4.65%204.01-4.49%204.17-4.34%204.33-4.18%204.5-4.01%204.64-3.83%204.79-3.66%204.93-3.48%205.07-3.28%205.21-3.1%203.44-1.87v276.53l-3.44-1.87z%22%20fill%3D%22%23fff%22%20filter%3D%22url%28%23close-b%29%22%2F%3E%3Cg%3E%3Cuse%20xlink%3Ahref%3D%22%23close-c%22%20fill%3D%22%23ff6600%22%2F%3E%3Cuse%20xlink%3Ahref%3D%22%23close-c%22%20fill-opacity%3D%220%22%20stroke%3D%22%23ff6600%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E');
        },

        ...mapMutations({
            setNavigation: types.NAVIGATION_SET_NAVIGATION
        }),

        showSettingsView() {
            this.$router.push('/preferences/settings');
        },

        showContextView() {
            this.$router.push('/preferences/context');
        },

        showGroupAdminView() {
            this.$router.push('/preferences/groupAdmin');
        },

        isGroupAdmin() {
            const roleId = parseInt(this.role, 0);
            if (this.client.children && this.client.children.length > 0 &&
                (roleId === 3 || roleId === 4)) {
                return true;
            }
            return false;
        },

        animateTOC(moduleId, pagePath) {
            this.resetActive = false;
            this.resetActive = true;
            // Open the expansion panel for appropriate panel
            // Scroll to options
            const options = {
                container: '#navDraw',
                duration: 500,
                easing: 'ease',
                offset: -60,
                force: true,
                cancelable: true,
                onStart: false,
                onDone: false,
                onCancel: false,
                x: false,
                y: true
            };

            // Scroll to current heading
            // TODO: Can't use setTimeout
            // Need to wait for expansion panel to expand and tree to create
            // the nodes in the DOM.
            setTimeout(() => {
                VueScrollTo.scrollTo(
                    `#toc-node-${moduleId}-${pagePath.substring(0, pagePath.length - 3)}`,
                    250,
                    options
                );
            }, 2000);
        },

        onPageSelected(details) {
            if (details && details.path) {
                // Keep track of active TOC nodes
                this.tocActive = details.path;

                // Display the page when selected from TOC
                this.$router.push({
                    name: 'Page',
                    params: {
                        moduleId: details.moduleId,
                        pagePath: details.path
                    }
                });
            }
        },

        async getTableOfContents() {
            if (this.loading) return;
            this.tocs = [];

            try {
                const tocPromises = [];
                this.activatedCEModuleItems.forEach((cemodule) => {
                    tocPromises.push(
                        content.getToc(cemodule.id, 'master')
                    );
                });

                // NOTE: Need to remove any empty children from TOC as the
                // vuetify Tree control selection process does not work
                const cleanChildren = (toc) => {
                    /* eslint-disable no-param-reassign */
                    toc.vpath = toc.path;
                    /* eslint-enable no-param-reassign */
                    if (toc.children && toc.children.length === 0) {
                        /* eslint-disable no-param-reassign */
                        delete toc.children;
                        /* eslint-enable no-param-reassign */
                    } else if (toc.children) {
                        const ptoc = JSON.parse(JSON.stringify(toc));
                        ptoc.parentId = toc.id;
                        ptoc.children = [];
                        // toc.children.unshift(ptoc);
                        /* eslint-disable no-param-reassign */
                        // toc.vpath += '_PARENT';
                        /* eslint-enable no-param-reassign */
                        toc.children.forEach((child) => {
                            cleanChildren(child);
                        });
                    }

                    // Apply context here
                    // Remove any HTML tags from the context key value
                    // No need to render using formatting
                    // TODO: Speed this up by just using regex instead of
                    // nunjucks
                    const text = nunjucks.renderString(
                        mergeFieldToLowerCase(toc.name),
                        this.contextItemValues
                    );
                    /* eslint-disable no-param-reassign */
                    toc.name = striptags(text);
                    /* eslint-enable no-param-reassign */
                    return toc;
                };

                let filter = node => node.visible;
                // Admins get all nodes regardless of visibility
                if (this.isAllowedTo(4) ||
                    this.isAllowedTo(3) ||
                    this.isAllowedTo(2)) filter = node => true;
                const responses = await Promise.all(tocPromises);
                responses.forEach((response, index) => {
                    this.tocs.push({
                        moduleId: this.activatedCEModuleItems[index].id,
                        toc: treeUtils.filterTree(cleanChildren(response.data),
                            filter)
                    });
                });

                // Generate navigation data set
                this.setNavigation(this.tocs);
                // await this.$store.dispatch('published/getAllAppliedUpdates');
                // await this.$store.dispatch('published/getAllComplispaceUpdates');
                this.getModuleUpdates();
            } catch (err) {
                this.showErrorAlert(err.message);
            } finally {
                // this.setLoading(false);
            }
        },

        async getUpdate(isCheckUpdate) {
            // Sanity check - it takes a while for activated cemodules to populate
            // Triggered by the watcher
            // if (this.activatedCEModules.length === 0) return;
            if (this.loading) return;
            this.setLoading(true);
            try {
                await this.$store.dispatch('published/getAllAppliedUpdates');
                await this.$store.dispatch('published/getAllComplispaceUpdates');
                this.getModuleUpdates();
                if (isCheckUpdate) {
                    if (Object.keys(this.moduleUpdates).length > 0) {
                        this.title = 'Updates available';
                        this.message = 'These are now visible in your sidebar module list.';
                    } else {
                        this.title = 'No updates available';
                        this.message = 'When updates are available they will be visible on your sidebar module list.';
                    }
                    this.showCheckUpdateMessageDialog = true;
                }
            } catch (error) {
                this.showErrorAlert(error.message);
            } finally {
                this.setLoading(false);
            }
        },

        // TODO: Optimise this once DB structure is solid
        async getModuleUpdates() {
            this.moduleItems = [];
            // Add module name to each update entry
            const mapped = this.appliedUpdateItems.map((item) => {
                const mappedItem = Object.assign({}, item);
                const foundModule = _.chain(this.activatedCEModules).filter(
                    cemoduleItem => cemoduleItem.id === item.moduleId
                ).first().value();
                if (foundModule) {
                    mappedItem.moduleName = foundModule.name;
                }
                return mappedItem;
            });
            // Group the latest updates my module
            const csGroupedByModule = _.groupBy(mapped, 'moduleName');

            Object.keys(csGroupedByModule).forEach((key) => {
                const items = csGroupedByModule[key];
                const latestPublished = _.maxBy(items, 'publishId');

                // Convert the markdown summaries into html
                const summary = items.reduce((text, summary) => {
                    return `${text}<br/><br/><h4 class="orange--text">
                        ${new Date(summary.createdAt)}</h4>
                        <br/>${md.render(summary.publishSummary)}`;
                }, '');

                csGroupedByModule[key] = {
                    publish: latestPublished,
                    updateNumber: items.length,
                    summary
                };
            });

            this.moduleUpdates = csGroupedByModule;
            this.expansionPanelStates = [];
            this.activatedCEModuleItems.forEach((cemodule) => {
                let tempItem = null;
                Object.keys(this.moduleUpdates).forEach((key) => {
                    const item = this.moduleUpdates[key];
                    if (item.publish.moduleId === cemodule.id) {
                        tempItem = item;
                    }
                });
                if (this.moduleId) {
                    if (cemodule.id === this.moduleId) {
                        this.expansionPanelStates.push(true);
                    } else {
                        this.expansionPanelStates.push(false);
                    }
                }
                this.moduleItems.push({ actionItem: cemodule, updateItem: tempItem });
                // unorderedItems.push({ actionItem: cemodule, updateItem: tempItem });
            });
            /*
            const priorities = [
                'duty of care',
                'child protection',
                'health and safety',
                'registration',
                'privacy',
                'complaints',
                'compliance',
                'risk'
            ];

            const pmap = [];
            unorderedItems.forEach((e, i) => {
                let p = priorities.findIndex((ep) => {
                    return e.actionItem.name.trim().toLowerCase().includes(ep);
                });
                p = p === -1 ? 1e50 : p;

                pmap.push({
                    index: i,
                    priority: p
                });
            });

            pmap.sort((e1, e2) => { return e1.priority > e2.priority; });

            pmap.forEach((e) => {
                this.moduleItems.push(unorderedItems[e.index]);
            });
            */
        },

        async showUpdateDetail(summary, publishId, moduleId) {
            if (!this.hasAccess('processupdatesaccessTable')) {
                return;
            }
            this.setLoading(true);
            try {
                const response = await this.getDiffDate(publishId);
                this.diff = response.data;
                this.summary = summary;
                this.merge.publishId = publishId;
                this.merge.moduleId = moduleId;
                this.showUpdateDialog = true;
            } catch (err) {
                this.showErrorAlert(err.message);
            } finally {
                this.setLoading(false);
            }
        },

        async getDiffDate(publishId) {
            return publish.getDiff(publishId);
        },

        updateSideNav() {
            this.getUpdate(false);
            const { moduleId, pagePath } = this.$route.params;
            if (moduleId !== undefined && pagePath !== undefined) {
                const { lineage } = this.navigation[moduleId][pagePath];
                const firstPath = lineage[0].path;
                this.$router.push({
                    name: 'TempPage',
                    params: { moduleId, pagePath: firstPath }
                });
            }
        },

        treeUpdate(details) {
            this.changePanelStates(details.moduleId);
            if (this.$refs.tree) {
                for (let i = 0; i < this.$refs.tree.length; i++) {
                    if (this.$refs.tree[i].moduleId === details.moduleId) {
                        this.$refs.tree[i].updateTree(details.moduleId, details.path);
                    }
                }
            }
            this.animateTOC(details.moduleId, details.path);
        },

        toggleSideNav() {
            this.$store.commit(types.APPEARANCE_TOGGLE_SIDE_NAV);
        },

        changePanelStates(moduleId) {
            this.expansionPanelStates = [];
            this.activatedCEModuleItems.forEach((cemodule) => {
                if (cemodule.id === moduleId) {
                    this.expansionPanelStates.push(true);
                } else {
                    this.expansionPanelStates.push(false);
                }
            });
        }
    }
};
</script>

<style>
.theme--light.v-navigation-drawer {
  background-color: var(--v-info-base);
}

#nav-container {
    min-height: 65%;
}

#nav-container-preferences {
    min-height: 65%;
}

.logo-side-bottom-nav{
    margin: 80px;
    margin-bottom: 0;
}
.logo-side-bottom-nav>img{
    width: 100%;
}

.version-side-bottom-nav{
    margin: 60px;
    margin-bottom: 0;
}

.version-side-bottom-nav>span{
    width: 100%;
}

@media (max-height:812px){
  #nav-container {
    min-height: 60%;
  }
}

.logo-side-nav {
  width: 125px;
}
.nav-item{
  display: flex;
  align-items:center;
}
.nav-item-inner{
  display: flex;
  align-items: center;
  flex: 1;
  padding-left: 5px;
}
.nav-item-inner .nav-word{
  flex: 1;
}
.nav-item-inner .material-icons{
  flex: 0 0 auto;
}
.updateButton.v-btn{
  margin: 0px 0px;
}
.updateButton .v-btn__content{
  margin-bottom: 4px;
}

.v-expansion-panel__header__icon .v-icon {
  color: var(--v-secondary-base) !important;
}
.v-expansion-panel__header {
  max-width: 328px;
  padding-right: 0px;
}
.panel {
  line-height: 1.25;
}

.side-nav-left-close-arrow{
    left: -30px;
    top: 100px;
    z-index: 200;
    position: relative;
}

.nav-spliter {
    height: 100%;
    position: relative;
    width: 24px;
    background-color: green;
    float: right;
    right: -24px;
}
</style>



// WEBPACK FOOTER //
// src/components/core/AppSideNav.vue